import { get, post, put, del } from "../common/apiClient";

const MASTER = "/master-vocab";

// ── Topics ────────────────────────────────────────────────────────────────────
export const getTopics = () => get(`${MASTER}/topics`);
export const createTopic = (body) => post(`${MASTER}/topics`, body);
export const updateTopic = (id, body) => put(`${MASTER}/topics/${id}`, body);
export const deleteTopic = (id) => del(`${MASTER}/topics/${id}`);

// ── Master Vocab ──────────────────────────────────────────────────────────────
export const getMasterVocabs = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return get(`${MASTER}/vocab${query ? `?${query}` : ""}`);
};
export const createMasterVocab = (body) => post(`${MASTER}/vocab`, body);
export const updateMasterVocab = (id, body) => put(`${MASTER}/vocab/${id}`, body);
export const deleteMasterVocab = (id) => del(`${MASTER}/vocab/${id}`);
export const importMasterVocabs = (items) => post(`${MASTER}/vocab/import`, { items });
